import React from 'react';
import * as Yup from 'yup';

import { Button } from 'components/_shared/Button';
import { FormField, FormFieldset } from 'components/_shared/Form';
import { ROUTES, FIELD_VALIDATION } from '_constants';
import { ForgotPassLinkWrap, StyledLink, StyledForm } from './AuthForm.styles';

const validationSchema = Yup.object().shape({
  username: Yup.string().trim().required(FIELD_VALIDATION.REQUIRED),
  password: Yup.string().trim().required(FIELD_VALIDATION.REQUIRED)
});

export const AuthForm = ({ initialValues = {}, ...props }) => {
  const _initialValues = { username: '', password: '', ...initialValues };

  return (
    <StyledForm
      {...props}
      initialValues={_initialValues}
      validationSchema={validationSchema}
      header='Login'
      actions={[
        <Button key='submit' type='submit' variant='primary' fullWidth>
          Login
        </Button>
      ]}
    >
      <FormFieldset>
        <FormField
          label='Username'
          type='text'
          name='username'
          placeholder='Enter username'
        />
        <FormField
          label='Password'
          type='password'
          name='password'
          placeholder='Enter password'
        />
        <ForgotPassLinkWrap>
          <StyledLink to={ROUTES.FORGOT_PASSWORD}>Forgot password?</StyledLink>
        </ForgotPassLinkWrap>
      </FormFieldset>
    </StyledForm>
  );
};
